// Avis clients Google
export const reviews = [
  {
    id: 1,
    author: "Christopher Brown",
    rating: 5,
    text: "Déplacement rapide, arrivé à l'heure et conseils professionnels. Problème identifié et résolu dès la 1ère visite. Le cylindre installé par le promoteur n'était pas aux normes ni de bonne qualité, j'ai maintenant une serrure qui fonctionne, qui est aux normes avec un jeu de 5 clés pour à peine plus cher qu'un magasin de bricolage. Facture et garantie.",
    date: "Il y a 2 semaines"
  },
  {
    id: 2,
    author: "Marlo Royce",
    rating: 5,
    text: "Très bonne entreprise, ils ont été très réactifs et le problème a été réglé rapidement. En plus de ça, ils sont très agréables et très humains. Je conseille fortement.",
    date: "Il y a 1 mois"
  },
  {
    id: 3,
    author: "Nadia Ghezlane",
    rating: 5,
    text: "Service de qualité rapide et efficace. J'ai fait appel à Serrurier Lieusaint pour une ouverture de porte en urgence et l'intervention s'est faite en moins de 30 minutes. Serrurier très professionnel disponible 24h/24 et 7j/7. Je recommande vivement.",
    date: "Il y a 1 mois"
  },
  {
    id: 4,
    author: "Jen Cala",
    rating: 5,
    text: "Intervention très rapide et efficace sur une porte claquée avec clé à l'intérieur. Tarif conforme à celui annoncé. Je recommande.",
    date: "Il y a 2 mois"
  },
  {
    id: 5,
    author: "Carolina Lucy",
    rating: 5,
    text: "Je recommande vivement cette entreprise. En cas de souci vous pouvez leur faire confiance : ils sont très efficaces, rapides et d'une grande gentillesse. Ils m'ont énormément aidée dans une situation d'urgence.",
    date: "Il y a 2 mois"
  },
  {
    id: 6,
    author: "rihmed-din reghis",
    rating: 5,
    text: "Rapide, efficace et professionnel. Je recommande. Il a changé ma serrure qui ne marchait plus.",
    date: "Il y a 3 mois"
  },
  {
    id: 7,
    author: "Laurent Bupto",
    rating: 5,
    text: "Intervention 10/10. Rapidité au top. Travail de qualité avec le souci du détail. Je suis extrêmement satisfait et je recommande vivement.",
    date: "Il y a 3 mois"
  },
  {
    id: 8,
    author: "Fouad",
    rating: 5,
    text: "J'habite à Brie-Comte-Robert et j'avais perdu mes clés. Intervention rapide, ouverture et changement de serrure avec un prix raisonnable. Je recommande.",
    date: "Il y a 4 mois"
  },
  {
    id: 9,
    author: "Mag Veissier",
    rating: 5,
    text: "Entreprise sérieuse et efficace. Intervention rapide et de qualité avec des tarifs très compétitifs.",
    date: "Il y a 4 mois"
  },
  {
    id: 10,
    author: "Léa Che",
    rating: 5,
    text: "J'ai été enfermée devant chez moi et en moins d'une heure le problème était réglé. Très gentil et efficace.",
    date: "Il y a 5 mois"
  },
  {
    id: 11,
    author: "Naomi Quillin",
    rating: 5,
    text: "Très efficace et très rapide. Très satisfaite de l'intervention.",
    date: "Il y a 5 mois"
  },
  {
    id: 12,
    author: "Titia La Rose",
    rating: 5,
    text: "Une équipe extraordinaire, très efficace et très sérieuse. Les tarifs sont très abordables et l'intervention a été rapide. Je recommande fortement.",
    date: "Il y a 6 mois"
  }
];

// Note moyenne Google
export const googleRating = {
  score: 4.9,
  totalReviews: reviews.length,
  source: "Google"
};

export default reviews;
